import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6" }

import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroupField from './EmployeeChangesGroupField.vue';
    import { Alert } from '@/components/ui/alert';
    import type { AlertVariants } from '@/components/ui/alert';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeChangesGroup',
  props: {
    data: {},
    values: {},
    employee: {},
    alert: {},
    alertVariant: { default: 'warning' }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.alert)
      ? (_openBlock(), _createBlock(_unref(Alert), {
          key: 0,
          variant: _ctx.alertVariant
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.alert), 1)
          ]),
          _: 1
        }, 8, ["variant"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (value) => {
      return (_openBlock(), _createBlock(EmployeeChangesGroupField, {
        key: value.name,
        data: _ctx.data,
        name: value.name,
        group: value.group,
        groupKey: value.key,
        oldValue: value.oldValue,
        realValue: value.realValue,
        updateValue: value.updateValue,
        employee: _ctx.employee,
        translation: value.translation
      }, null, 8, ["data", "name", "group", "groupKey", "oldValue", "realValue", "updateValue", "employee", "translation"]))
    }), 128))
  ]))
}
}

})